import { render, staticRenderFns } from "./NewArtwork.vue?vue&type=template&id=37a8e365"
import script from "./NewArtwork.vue?vue&type=script&lang=js"
export * from "./NewArtwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports